import { MutationTree } from "vuex/types";

import { PrismState } from "./types";

const mutations: MutationTree<PrismState> = {};

export default mutations;
